import React from "react";

const SecondStep = ({ projectData, setProjectData }) => {
  return (
    <>
      <div id="wizard_Service" className="tab-pane" role="tabpanel">
        <h4 className="title">Project Amount and Period</h4>
        <div className="row sp15">
          <div className="col-12">
            <label className="form-label mb-0">Amount</label>
            <div className="input-group">
              <input
                value={projectData.amount}
                onChange={(e) =>
                  setProjectData((prevData) => ({
                    ...prevData,
                    amount: e.target.value,
                  }))
                }
                name="dzName"
                required=""
                type="number"
                className="form-control"
                placeholder="Project Amount"
              />
            </div>
          </div>
          <div className="col-md-6">
            <label className="form-label mb-0">Start Date</label>
            <div className="input-group">
              <input
                value={projectData.start_date}
                onChange={(e) =>
                  setProjectData((prevData) => ({
                    ...prevData,
                    start_date: e.target.value,
                  }))
                }
                name="dzName"
                required=""
                type="date"
                className="form-control"
                placeholder="Project Start Date"
              />
            </div>
          </div>
          <div className="col-md-6">
            <label className="form-label mb-0">End Date</label>
            <div className="input-group">
              <input
                value={projectData.end_date}
                onChange={(e) =>
                  setProjectData((prevData) => ({
                    ...prevData,
                    end_date: e.target.value,
                  }))
                }
                name="dzName"
                required=""
                type="date"
                className="form-control"
                placeholder="Project End Date"
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default SecondStep;
